import { useSubscriptionContext } from '@/contexts/SubscriptionContext';
import { FeatureKey } from '@/types/subscription';

// Legacy constant for UI display - eventually fetch from DB
export const SUBSCRIPTION_PLANS = [
  {
    id: 'basic',
    name: 'Basic Plan',
    description: 'Perfect for small restaurants',
    price: 29,
    interval: 'month',
    features: ['Up to 100 menu items', 'Basic analytics', 'WhatsApp integration']
  },
  {
    id: 'pro',
    name: 'Pro Plan',
    description: 'For growing restaurants',
    price: 79,
    interval: 'month',
    features: ['Unlimited menu items', 'Advanced analytics', 'Inventory', 'Loyalty']
  },
  {
    id: 'enterprise',
    name: 'Enterprise Plan',
    description: 'For restaurant chains',
    price: 999,
    interval: 'year',
    features: ['Everything in Pro', 'White-label', 'Priority support']
  }
];

export function useSubscription() {
  const context = useSubscriptionContext();
  
  const canAccess = async (feature: FeatureKey, currentUsage?: number): Promise<boolean> => {
    const result = await context.checkAccess(feature, currentUsage);
    return result.allowed;
  };

  const getFeatureLimit = (feature: FeatureKey): number | undefined => {
    if (!context.subscription) return undefined;
    const val = context.subscription.features[feature];
    return typeof val === 'number' ? val : undefined;
  };

  return {
    ...context,
    canAccess,
    getFeatureLimit,
    planName: context.subscription?.planName,
    isTrialing: context.subscription?.status === 'trialing',
    isValid: context.subscription?.isValid,
    // Legacy compatibility (optional)
    plans: SUBSCRIPTION_PLANS
  };
}
 